import settings from '../assets/settings.svg';
import React from 'react';
import styled from 'styled-components';

const Img = styled.img<{ disable: boolean }>`
  height: 24px;
  width: 24px;
  margin: 0 8px;
  visibility: ${({ disable }) => disable && 'hidden'};
  background-color: #F8F8FF;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
`;

const SettingsButton = ({ onClick, disable }) => {
  return (
    <Img
      id="settingsButton"
      disable={disable}
      src={settings}
      onClick={onClick}
    />
  );
};

export default SettingsButton;
